"use client";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./apollo-client";
import { ApolloCacheGc } from "./apollo-cache-gc";
import { Suspense } from "react";

export default function GraphQLProviders({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProvider client={apolloClient}>
      {/* Reads URL data (usePathname/useSearchParams). Under `cacheComponents`
          that must sit inside a Suspense boundary or the page cannot prerender.
          It renders nothing, so the fallback is null. */}
      <Suspense fallback={null}>
        <ApolloCacheGc />
      </Suspense>
      {children}
    </ApolloProvider>
  );
}
